import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { AppSidebarContainer } from '@/components/app/app-sidebar-container'
import { useBackToList } from '@/components/app/use-back-to-list'
import { MillsheetDetailContainer } from '@/components/screens/millsheet/millsheet-detail-container'

export const Route = createFileRoute('/t/$tenant_id/millsheets/$millsheet_id')({
  validateSearch: (search: Record<string, unknown>): { item?: string } => ({
    item: typeof search.item === 'string' ? search.item : undefined,
  }),
  component: Page,
})
function Page() {
  const { tenant_id: tenantId, millsheet_id: millsheetId } = Route.useParams()
  const { item } = Route.useSearch()
  const navigate = useNavigate()
  const backToList = useBackToList(() => {
    void navigate({ to: '/t/$tenant_id', params: { tenant_id: tenantId } })
  })
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebarContainer tenantId={tenantId} />
      <main className="min-w-0 flex-1 space-y-4 p-6">
        <MillsheetDetailContainer
          key={JSON.stringify([tenantId, millsheetId])}
          millsheetId={millsheetId}
          targetItemId={item}
          onBack={backToList}
        />
      </main>
    </div>
  )
}
